import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

const EmptyTaxonomyChart = (props: any) => {
  const theme = useContext(ThemeContext);

  const generateLinearGradientId = (id: string) => {
    const extraIdPart = props.extraIdPart;
    return `${id}_${extraIdPart as string}`;
  };

  return (
    <svg height="156" width="207" fill="none" viewBox="0 0 207 156" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="86" cy="70" fill={theme.colors.selection} r="70" />
      <g>
        <circle cx="86" cy="70" fill={`url(#${generateLinearGradientId('paint0_linear_1170_4234')})`} r="52" />
      </g>
      <g>
        <circle cx="149" cy="105" fill={`url(#${generateLinearGradientId('paint4_linear_1170_4234')})`} r="23" />
      </g>
      <path
        d="M86.3077 73.8182V73.2045C86.3077 72.7121 86.4137 72.2576 86.6259 71.8409C86.8418 71.4242 87.1543 71.089 87.5634 70.8352C87.9724 70.5814 88.4705 70.4545 89.0577 70.4545C89.6599 70.4545 90.1656 70.5795 90.5747 70.8295C90.9876 71.0795 91.3001 71.4129 91.5122 71.8295C91.7243 72.2462 91.8304 72.7045 91.8304 73.2045V73.8182C91.8304 74.3106 91.7224 74.7652 91.5065 75.1818C91.2944 75.5985 90.9819 75.9337 90.569 76.1875C90.1562 76.4413 89.6524 76.5682 89.0577 76.5682C88.463 76.5682 87.9611 76.4413 87.552 76.1875C87.1429 75.9337 86.8323 75.5985 86.6202 75.1818C86.4118 74.7652 86.3077 74.3106 86.3077 73.8182ZM88.2849 73.2045V73.8182C88.2849 74.0341 88.338 74.2481 88.444 74.4602C88.5539 74.6686 88.7584 74.7727 89.0577 74.7727C89.3721 74.7727 89.5785 74.6705 89.677 74.4659C89.7793 74.2614 89.8304 74.0455 89.8304 73.8182V73.2045C89.8304 72.9773 89.783 72.7576 89.6884 72.5455C89.5937 72.3333 89.3834 72.2273 89.0577 72.2273C88.7584 72.2273 88.5539 72.3333 88.444 72.5455C88.338 72.7576 88.2849 72.9773 88.2849 73.2045ZM80.2168 67.1591V66.5455C80.2168 66.0455 80.3247 65.5871 80.5406 65.1705C80.7603 64.7538 81.0747 64.4205 81.4838 64.1705C81.8929 63.9205 82.3872 63.7955 82.9668 63.7955C83.569 63.7955 84.0747 63.9205 84.4838 64.1705C84.8967 64.4205 85.2092 64.7538 85.4213 65.1705C85.6334 65.5871 85.7395 66.0455 85.7395 66.5455V67.1591C85.7395 67.6591 85.6315 68.1155 85.4156 68.5284C85.2035 68.9413 84.891 69.2708 84.4781 69.517C84.0652 69.7633 83.5615 69.8864 82.9668 69.8864C82.3721 69.8864 81.8702 69.7614 81.4611 69.5114C81.052 69.2614 80.7414 68.9299 80.5293 68.517C80.3209 68.1042 80.2168 67.6515 80.2168 67.1591ZM82.2168 66.5455V67.1591C82.2168 67.3864 82.2698 67.6023 82.3759 67.8068C82.4819 68.0114 82.6789 68.1136 82.9668 68.1136C83.2812 68.1136 83.4876 68.0114 83.5861 67.8068C83.6884 67.6023 83.7395 67.3864 83.7395 67.1591V66.5455C83.7395 66.3182 83.6921 66.0985 83.5974 65.8864C83.5027 65.6742 83.2925 65.5682 82.9668 65.5682C82.6675 65.5682 82.4668 65.678 82.3645 65.8977C82.266 66.1136 82.2168 66.3295 82.2168 66.5455ZM81.1827 76L89.1827 64.3636H90.7963L82.7963 76H81.1827Z"
        fill={theme.colors.primary.c100}
      />
      <path
        d="M86 110C108.091 110 126 92.091 126 69.9992C126 48.0266 108.284 30.1918 86.3571 30L84.9286 30.0125C79.3277 30.1598 74.0136 31.4584 69.2143 33.6803L67.7857 34.3767C54.8518 41.0035 46 54.4676 46 69.9992C46 76.7028 47.649 83.0212 50.5634 88.571L51.5604 90.3568C57.5451 100.46 67.8488 107.703 79.9286 109.542L81.7143 109.773C83.1223 109.923 84.5522 110 86 110Z"
        stroke={`url(#${generateLinearGradientId('paint1_linear_1170_4234')})`}
        strokeWidth="8"
      />
      <path
        d="M67.7857 34.377C54.8518 41.0038 46 54.4679 46 69.9995C46 76.7031 47.649 83.0215 50.5634 88.5713"
        stroke={`url(#${generateLinearGradientId('paint2_linear_1170_4234')})`}
        strokeWidth="16"
      />
      <path
        d="M50.5634 88.5713C47.649 83.0215 46 76.7031 46 69.9995C46 58.3143 51.0104 47.7993 59 40.4859"
        stroke={`url(#${generateLinearGradientId('paint3_linear_1170_4234')})`}
        strokeWidth="16"
      />
      <path
        d="M141.009 109.561C141.068 110.645 142.388 111.117 143.166 110.339L146.243 107.262L152.626 112.836C153.711 113.75 155.336 113.664 156.364 112.636C157.392 111.608 157.478 109.983 156.564 108.898L150.991 102.514L154.067 99.4379C154.845 98.6603 154.372 97.3406 153.289 97.2804C149.655 97.0794 146.073 97.3723 142.428 97.4002C141.72 97.4056 141.134 97.9923 141.128 98.6996C141.101 102.345 140.808 105.927 141.009 109.561Z"
        stroke={`url(#${generateLinearGradientId('paint5_linear_1170_4234')})`}
        fillRule="evenodd"
      />
      <defs>
        <linearGradient
          id={generateLinearGradientId('paint0_linear_1170_4234')}
          gradientUnits="userSpaceOnUse"
          x1="62.5"
          x2="93.8929"
          y1="106.5"
          y2="22.1786"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={generateLinearGradientId('paint1_linear_1170_4234')}
          gradientUnits="userSpaceOnUse"
          x1="37.0714"
          x2="106.359"
          y1="146.787"
          y2="31.0712"
        >
          <stop stopColor={theme.colors.primary.c100} />
          <stop offset="1" stopColor={theme.colors.primary.c050} />
        </linearGradient>
        <linearGradient
          id={generateLinearGradientId('paint2_linear_1170_4234')}
          gradientUnits="userSpaceOnUse"
          x1="70.5"
          x2="63"
          y1="55.5"
          y2="37"
        >
          <stop stopColor="#C1D600" />
          <stop offset="1" stopColor="#DCF400" />
        </linearGradient>
        <linearGradient
          id={generateLinearGradientId('paint3_linear_1170_4234')}
          gradientUnits="userSpaceOnUse"
          x1="37.0714"
          x2="106.359"
          y1="146.787"
          y2="31.0713"
        >
          <stop stopColor={theme.colors.primary.c500} />
          <stop offset="1" stopColor={theme.colors.graph[5]} />
        </linearGradient>
        <linearGradient
          id={generateLinearGradientId('paint4_linear_1170_4234')}
          gradientUnits="userSpaceOnUse"
          x1="126.66"
          x2="158.533"
          y1="103.193"
          y2="124.606"
        >
          <stop stopColor={theme.colors.primary.c500} />
          <stop offset="1" stopColor={theme.colors.primary.c400} />
        </linearGradient>
        <linearGradient
          id={generateLinearGradientId('paint5_linear_1170_4234')}
          gradientUnits="userSpaceOnUse"
          x1="144.89"
          x2="154.89"
          y1="97.5605"
          y2="118.561"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.8" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default EmptyTaxonomyChart;
